<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card shaped>
        <v-card-title>
          <v-icon large left color="primary">mdi-file-chart-outline</v-icon>
          <span class="title font-weight-light">Активность отчётов</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" :loading="loading.download" :disabled="loading.report" @click="DownloadReport">
            <v-icon left>mdi-microsoft-excel</v-icon>Скачать Excel
          </v-btn>
        </v-card-title>
        <v-col>
          <v-expansion-panels flat>
            <v-expansion-panel>
              <v-expansion-panel-header>Немного об отчёте</v-expansion-panel-header>
              <v-expansion-panel-content>
                <p class="text-justify mb-1">
                  Кто и как часто пользуется клиентскими отчётами «Прайс-мониторинг» и «Доля продаж»: входы —
                  открытия экрана отчёта, выгрузки — скачивания Excel. Строка — логин, отчёт и месяц; ниже сводка по
                  компаниям за период.
                </p>
                <p class="text-justify mb-0">
                  Данные копятся с момента запуска трекинга; период по умолчанию — текущий год.
                </p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-form ref="form" @submit.prevent="LoadReport">
          <v-row class="px-4">
            <v-col cols="12" sm="6" md="2">
              <v-text-field v-model="search.dateStart" type="date" label="Дата с" persistent-hint hint="Пусто — 1 января"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-text-field v-model="search.dateEnd" type="date" label="Дата по" persistent-hint hint="Пусто — сегодня"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select
                v-model="search.pageNames"
                :items="options.reports"
                item-text="title"
                item-value="name"
                label="Отчёты"
                multiple
                chips
                small-chips
                deletable-chips
                :loading="loading.options"
                persistent-hint
                hint="Пусто — все"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="search.search" label="Логин или компания" prepend-icon="mdi-magnify" clearable></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2" class="d-flex align-center">
              <v-btn color="primary" type="submit" :loading="loading.report" block>Показать</v-btn>
            </v-col>
          </v-row>
        </v-form>

        <v-row class="px-4" v-if="report.dateStart">
          <v-col class="caption grey--text pt-0">Период: {{ FormatDate(report.dateStart) }} — {{ FormatDate(report.dateEnd) }}</v-col>
        </v-row>

        <v-card-subtitle class="pb-0">По компаниям</v-card-subtitle>
        <v-data-table
          :headers="companyHeaders"
          :items="report.companies"
          :loading="loading.report"
          :items-per-page="10"
          class="elevation-1 mb-6"
          dense
        >
          <template v-slot:item.company="{ item }">{{ item.company || "Без компании" }}</template>
          <template v-slot:item.lastView="{ item }">{{ FormatDateTime(item.lastView) }}</template>
          <template v-slot:item.lastExport="{ item }">{{ FormatDateTime(item.lastExport) }}</template>
        </v-data-table>

        <v-card-subtitle class="pb-0">По логинам и месяцам</v-card-subtitle>
        <v-data-table
          :headers="headers"
          :items="report.rows"
          :loading="loading.report"
          :items-per-page="50"
          :footer-props="{ 'items-per-page-options': [50, 100, 500, -1] }"
          class="elevation-1"
        >
          <template v-slot:item.lastView="{ item }">{{ FormatDateTime(item.lastView) }}</template>
          <template v-slot:item.lastExport="{ item }">{{ FormatDateTime(item.lastExport) }}</template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    search: { dateStart: "", dateEnd: "", pageNames: [], search: "" },
    options: { reports: [] },
    report: { rows: [], companies: [], dateStart: null, dateEnd: null },
    loading: { options: true, report: false, download: false },
    headers: [
      { text: "Логин", value: "login" },
      { text: "Компания", value: "company" },
      { text: "Роль", value: "role" },
      { text: "Отчёт", value: "reportTitle" },
      { text: "Месяц", value: "month" },
      { text: "Входов", value: "views", align: "end" },
      { text: "Выгрузок", value: "exports", align: "end" },
      { text: "Последний вход", value: "lastView" },
      { text: "Последняя выгрузка", value: "lastExport" },
    ],
    companyHeaders: [
      { text: "Компания", value: "company" },
      { text: "Отчёт", value: "reportTitle" },
      { text: "Логинов", value: "logins", align: "end" },
      { text: "Входов", value: "views", align: "end" },
      { text: "Выгрузок", value: "exports", align: "end" },
      { text: "Последний вход", value: "lastView" },
      { text: "Последняя выгрузка", value: "lastExport" },
    ],
  }),
  async mounted() {
    await this.GetFilterOptions();
    this.LoadReport();
  },
  methods: {
    async GetFilterOptions() {
      this.loading.options = true;
      try {
        this.options = await this.$store.dispatch("REPORT_ACTIVITY_FILTER_OPTIONS");
      } catch (error) {
        window.console.log(error);
      } finally {
        this.loading.options = false;
      }
    },
    Request() {
      return {
        dateStart: this.search.dateStart || null,
        dateEnd: this.search.dateEnd || null,
        pageNames: this.search.pageNames,
        search: this.search.search || null,
      };
    },
    async LoadReport() {
      this.loading.report = true;
      try {
        this.report = await this.$store.dispatch("REPORT_ACTIVITY_REPORT", this.Request());
      } catch (error) {
        window.console.log(error);
      } finally {
        this.loading.report = false;
      }
    },
    DownloadReport() {
      this.loading.download = true;
      this.$store
        .dispatch("DOWNLOAD_REPORT_ACTIVITY_REPORT", this.Request())
        .catch((error) => window.console.log(error))
        .finally(() => {
          this.loading.download = false;
        });
    },
    FormatDate(value) {
      return value ? this.$options.filters.toDate(String(value).substr(0, 10)) : "";
    },
    FormatDateTime(value) {
      if (!value) return "";
      const d = new Date(value);
      return d.toLocaleString("ru-RU", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" });
    },
  },
};
</script>
